import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import { ListCourse } from './internalComponents/ListCourse';

/**
 * Ce composant représente la page de gestion des cours.
 */
export class CoursesPage extends React.Component {
    /**
     * le rendu de la classe CoursesPage
     * @returns {JSX.element}
     */
    render() {
        return (
            <PageChorinitia allowedUsers={[UserRole.ADMIN]}>
                <ListCourse/>
            </PageChorinitia>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CoursesPage/CoursesPage.tsx